export default __webpack_public_path__ + "locales/es/Payments.json?hash=79f29e9e5ebc6ccda8c361a29f92490b";